import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import Accordion from 'core/components/Accordion';
import DatePicker from 'core/components/DateTimePicker/SingleDatePicker';
import Input from 'pages/Dashboard/components/Input';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';

export default function PatientOccupationInfo() {
  const { control } = useFormContext();
  return (
    <Accordion
      defaultExpanded
      header="Occupation"
      disableGutters
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-2 populate-form gap-form-row flex flex-col w-full' }}
    >
      <div className="flex w-full items-center gap-form-field">
        <Controller
          name="occupation"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              className="w-1/3"
              label="Occupation"
              placeholder="Occupation"
              id="occupation"
            />
          )}
        />
        <Controller
          name="occupationStartDate"
          control={control}
          render={({ field }) => (
            <Wrapper
              label="Start Date"
              id="occupation-start-date"
              className="w-1/3"
            >
              <DatePicker
                {...field}
                className="!w-full"
                showDateButtons={false}
                disableFuture
              />
            </Wrapper>
          )}
        />
      </div>
    </Accordion>
  );
}
